module.exports = __webpack_public_path__ + "static/media/vi.b19b54ab.svg";